import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./bringoz-eta-tooltip.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-eta-tooltip',
  templateUrl: './bringoz-eta-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozEtaTooltipComponent implements OnInit, OnChanges {

  @Input() eta: any;
  @Input() timeZoneId: string;
  @Input() configZoneId: string;

  public timeZoneOffsetDiff: number;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.checkTimeZoneOffsetDiff();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.eta && !changes.eta.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.eta);
    return this.timeZoneOffsetDiff !== 0;
  }

}
